// scroll-reveal.js — global helper for all scroll-reveal sections
(function () {
  const sections = document.querySelectorAll('[data-sr-section]');
  if (!sections.length) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal observer
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const el = e.target;
          if (e.isIntersecting) {
            el.classList.add('sr-revealed');
            // Kinetic heading
            if (!prefersReduced && el.dataset.mode === 'kinetic') attachKinetic(el);
            io.unobserve(el);
          }
        });
      }, { threshold: 0.12 }) // lower threshold so it triggers reliably
    : null;

  sections.forEach((el) => {
    // if no IO support, just reveal
    if (!io || prefersReduced) el.classList.add('sr-revealed');
    else io.observe(el);

    // Arrow scroll
    const arrow = el.querySelector('[data-sr-arrow]');
    if (arrow) {
      arrow.addEventListener('click', () => {
        const next = el.nextElementSibling;
        if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  });

  function attachKinetic(root) {
    const heading = root.querySelector('.sr-heading');
    if (!heading) return;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const rect = root.getBoundingClientRect();
        const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const centerDist = Math.abs(rect.top + rect.height / 2 - vh / 2);
        const vis = Math.max(0, 1 - centerDist / (vh * 0.9)); // 0..1
        const scale = 0.98 + 0.06 * vis;
        const ls = (1 - vis) * 0.02;
        heading.style.transform = `scale(${scale.toFixed(3)})`;
        heading.style.letterSpacing = `${ls.toFixed(3)}em`;
        ticking = false;
      });
    };

    const watch = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
        } else {
          window.removeEventListener('scroll', onScroll);
          if (heading) {
            heading.style.transform = '';
            heading.style.letterSpacing = '';
          }
        }
      });
    }, { threshold: 0.1 });

    watch.observe(root);
  }
})();